import { createServiceFactory } from '@/services/factory'
import { createMockAuthService } from './auth.mock'
import { createHttpAuthService } from './auth.http'

export type { AuthService, AuthLoginResult, AuthLogoutParams } from './auth.service'

export const getAuthService = createServiceFactory(
  'auth',
  createMockAuthService,
  createHttpAuthService
)
